<section class="main-wrap inner-views dashboard-wrap" [ngClass]="{ 'menu-open in': !toggleClass }">
  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45">
      </button>

      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>

  <div class="container-wrap">
    <div class="heading-container sidebar-container" id="menu">

      <div class="row">
        <div class="col">

          <app-logo></app-logo>

          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45">
            </button>
          </div>

          <app-header></app-header>
        </div>
      </div>
    </div>

    <div class="content-container">
      <app-user-photo-uploader [navigateTo]="[redirectTo]"></app-user-photo-uploader>
    </div>

  </div>
</section>
